module.exports = __webpack_public_path__ + "770291ce177347871c2c0e0f6ff8b047.pdf";